var React = require('react');

var Timeline = React.createClass({
    render: function(){
        return (
            <div className="soccerTimeline desktop sub-module" data-behavior="soccer_timeline">
                    <div className="teamWrap away">
                        <a href="#">
                            <div className="logo">
                               <img alt="" src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png&amp;w=22&amp;site=espnfc" width="22" />
                            </div>
                            <div className="teamName">MUN</div>
                        </a>
                    </div>

                    <div className="gameProgressWrap" style={{width:'100%'}}>

                       <div className="gameProgress">

                            <ul className="timeline">
                                <li style={{left:'10px'}}>
                                    <div className="number">6</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification away">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip bottom">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-redcard"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li className="double-notification" style={{left:'50px'}}>
                                    <div className="number">16</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification away">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip bottom">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                            </div>
                                        </div>
                                        <div className="desktop iconNotification home">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip top">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-redcard"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li style={{left:'115px'}}>
                                    <div className="number">22</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification away group">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <div className="groupTooltipWrap bottom">
                                                            <div className="playerWrap">Player Tooltip</div>
                                                            <div className="playerWrap">
                                                                <div className="playerOn"><span>On:</span> P. Name</div>
                                                                <div className="playerOff">|<span> Off:</span> P. Name</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-substitution-before icon-substitution"></span>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                 <li style={{left:'180px'}}>
                                    <div className="number">28</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification home">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip top">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-ball-before icon-soccerball"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li style={{left:'198px'}}>
                                    <div className="number">29</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification home">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip top">
                                                            <div className="playerOn"><span>On:</span> P. Name</div>
                                                            <div className="playerOff">|<span> Off:</span> P. Name</div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-substitution-before icon-substitution"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li style={{left:'250px'}}>
                                    <div className="number">39</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification away">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip bottom">
                                                            <div className="playerOn"><span>On:</span> P. Name</div>
                                                            <div className="playerOff">|<span> Off:</span> P. Name</div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-substitution-before icon-substitution"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li style={{left:'285px'}}>
                                    <div className="number">41</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification home">
                                            <div className="iconWrap">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip top">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                            </div>
                                        </div>
                                    </div>style={{left:'435px'}}>
                                    <div className="number">63</div>
                                    <div className="wrapper">
                                        <div className="desktop iconNotification away">
                                            <div className="iconWrap active">
                                                <div className="tooltipWrap">
                                                    <div className="tooltip">
                                                        <span className="playerTooltip bottom">Player Tooltip</span>
                                                    </div>
                                                </div>
                                                <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li style={{right:0}}><span className="gameTimeIndicator stroke">FT</span></li>
                            </ul>

                        </div>
                    </div>


                    <div className="teamWrap home">
                        <a href="#">
                            <div className="logo">
                                <img alt="" src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png&amp;w=22&amp;site=espnfc" width="22" />
                            </div>
                            <div className="teamName">Manchester City</div>
                        </a>
                    </div>

                    <div className="timeline-controls">
                        <a className="icon-font-before icon-listen02-solid-before timeline-link" href="#">Listen</a>
                        <a className="icon-font-before icon-watch-outline-before timeline-link" href="#">Watch</a>
                        <ul className="arrows">
                            <li>
                                <span id="horizDragLeft" className="arrow icon-font-before icon-caret-left-solid-before"></span>
                            </li>
                            <li>
                                <span id="horizDragRight" className="arrow icon-font-before icon-caret-right-solid-before"></span>
                            </li>
                        </ul>
                    </div>

            </div>
        );
    }
})

module.exports = Timeline;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/HorizontalTimeline.jsx
 **/